import { apiClient, assertOk } from "@/api/generated/client.ts"

export const deleteDataPoint = async (id: number) => {
  const { error, response } = await apiClient.DELETE("/api/DataPoints/{id}", {
    params: { path: { id } },
    parseAs: "text",
  })
  assertOk(response, error)
}
